module.exports = __webpack_public_path__ + "static/media/img_apps_feature_cm.3f422c94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/App/components/imgs/img_apps_feature_cm.svg
// module id = 808
// module chunks = 0